const footerDropdownButtons = document.querySelectorAll('.dropdown-button');

footerDropdownButtons.forEach(button => {
  button.addEventListener('click', event => {
    if (button.classList.contains('active')) {
      button.classList.remove('active')
      slideUp(button.nextElementSibling, 300);
    } else {
      button.classList.add('active')
      slideDown(button.nextElementSibling, 300);
    }
  });
});

document.getElementById('pop-attentive').addEventListener('click', function (){
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', 'S8tUa2']);
});

document.getElementById('pop-attentive-mobile').addEventListener('click', function (){
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', 'SyVbZF']);
});